//统一接口把所有方法暴露出去require.context(要查找的目录的路径，是否查找子目录，要匹配文件的正则表达式)
const files = require.context('./api', true, /\.js$/)

function importAll(r) {
  let lib = {}
  // console.log(r.keys()) //可以得到一串数组，是所有以.js为后缀的文件路径
  r.keys().forEach(key => {
    let m = r(key).default
    if (m!=null) {
      let n = m.name || getfilename(key)
      // console.log(m)
      lib[n] = m
    }
  })
  // console.log(__modules, 'll')
  return lib
}

//获取路径中的文件名称
function getfilename(filename) {
  // console.log('filename>>' + filename)
  let arr = filename.split('/')
  let filenameword = arr[arr.length - 1].split('.')
  return filenameword[0]
}

// console.log(lib)
export default importAll(files);



// WEBPACK FOOTER //
// ./src/request/index.js